import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Input } from '@angular/core';
import { FormArray, FormControl, FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { addInputMatChipGrid, pasteInputMatChipGrid } from '../../utils/mat-chip-grid-methods';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-chip-input',
  templateUrl: './chip-input.component.html',
  styleUrls: ['./chip-input.component.scss']
})
export class ChipInputComponent {
  @Input() label = '';
  @Input() placeholder = '';
  @Input() errorMessage?: string;
  @Input() hintMessage?: string;
  @Input() disabled = false;
  @Input() validateFn: (value: string) => boolean = () => true;

  inputs: string[] = [];

  invalidInput = false;

  form: FormGroup

  separatorKeyCodes = [COMMA, ENTER];

  constructor(private builder: NonNullableFormBuilder) {
    this.form = this.builder.group({
      chips: builder.array<string>(this.inputs),
      input: builder.control('')
    })
  }

  removeInputChip(index: number): void {
    if(index >= 0){
      this.inputs.splice(index, 1);
      this.getChipForm.removeAt(index);
    }
  }

  get getChipForm(): FormArray<FormControl<string>> {
    return this.form.controls.chips as FormArray<FormControl<string>>;
  }

  addChip(event: MatChipInputEvent): void {
    addInputMatChipGrid(event, this.form.controls.chips as FormArray<FormControl<string>>);
    this.checkInputs();
    this.inputs = this.form.controls.chips.value;
  }

  checkInputs(): void {
    this.invalidInput = !this.inputs.every(this.validateFn)
  }

  pasteEmailList(event: ClipboardEvent): void {
    pasteInputMatChipGrid(event,this.form.controls.chips as FormArray<FormControl<string>>);
    this.checkInputs();
    this.inputs = this.form.controls.chips.value;
  }

  public getValue(): string[] {
    return this.inputs;
  }
}
